import { saturntheme } from '@jotta/ui/themes/saturn'
import { startApp } from '../App'

startApp(saturntheme)
